import {object, string} from 'yup';

import {CustomAuthentication} from "@store/session";

import I18n from '@utils/i18n.utils';
import * as YupUtils from "@utils/yup.utils";

export const customSignInValidation = (customSignInData: CustomAuthentication) => {
  const requiredString = string().required(I18n.t("errors.required"));

  try {
    const schema = object().shape({
      email: requiredString.email(I18n.t("errors.email")),
      password: requiredString,
    });

    schema.validateSync(customSignInData, {abortEarly: false});
    return {};
  } catch (err) {
    return YupUtils.transformError(err as any);
  }
}
